import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Step } from "semantic-ui-react";
import { AppStoreContext } from "../stores/AppStore";
import { routes } from "../stores/routes";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../hooks/useWindowSize";
import "./AppStepper.css";

export default observer(function AppStepper() {
  const appStore = useContext(AppStoreContext);
  const [t] = useTranslation();
  const width = useWindowSize().width;
  const mobile = width <= 600;

  if (appStore.currentRoute.hidden) {
    return null;
  }

  return (
    <div style={{ maxWidth: 700, marginLeft: "auto", marginRight: "auto" }}>
      <Step.Group ordered={!mobile} unstackable widths={3}>
        {routes
          .filter(r => !r.hidden)
          .map(r => (
            <Step
              completed={false}
              active={appStore.currentRoute === r}
              disabled={appStore.currentRoute !== r}
              key={r.name}
            >
              <Step.Content>
                <Step.Title>{t(r.name)}</Step.Title>
              </Step.Content>
            </Step>
          ))}
      </Step.Group>
    </div>
  );
});
